// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"dbe938ba","424":"0ea3f6b0"}[chunkId] + ".chunk.css";
};